export default __webpack_public_path__ + "static/media/P200_Micropipette.5b23e8c2.svg";